import { requestData } from '../../config/services/datasets';
import { SERVER } from '../../config/server.config';
import * as TYPES from '../types';
import { customAlerts } from 'store/reducers/customEvents';

export const setCustomEvents = (results, teamId) => {
    return {
      type: TYPES.GET_CUSTOM_EVENTS,
      customEvents: results,
      teamId
    };
  };

export const setCustomAlerts = (results, user, teamId) => {
   return {
     type: TYPES.GET_TABLE_ALERTS,
     customAlerts: results,
     user,
     teamId
   };
 };

 export const saveAlerts = (alert, gameId) => {
  return {
    type: TYPES.SAVE_HITED_ALERTS,
    alert,
    gameId
  };
};

export const setSpeedAlerts = (speedAlerts, teamId) => {
  return {
    type: TYPES.SET_SPEED_ALERTS,
    speedAlerts,
    teamId
  };
};

export const loadCustomEvents = (teamId, isMobile) =>{
    return async (dispatch) => {
    const results = await requestData(SERVER.GET_CUSTOM_EVENTS(teamId, isMobile));
    let defaultCustom;
    if(results && results.length === 0){
      defaultCustom =[
        {
        name: '-' ,
        displayName: 'CustomBOne',
        num: 1
        },
        {
          name: '-',
          displayName: 'customBTwo',
          num: 2
        },
        {
          name: '-',
          displayName: 'customBThree',
          num: 3
        }
      ];
      dispatch(setCustomEvents(defaultCustom, teamId));
    }else{
      dispatch(setCustomEvents(results, teamId));
    }
  };   
};

export const loadTableAlerts = (user, teamId) =>{
  return async (dispatch) => {
  const results = await requestData(SERVER.GET_CUSTOM_ALERTS(user, teamId));
  let defaultCustom;
  if(!results || results.length === 0){
    defaultCustom ={
      headers: [],
      players: []
    };
    dispatch(setCustomAlerts(defaultCustom, user, teamId));
  }else if((results[0] && !results[0].customfieldview || results[0].customfieldview.length === 0)){
    defaultCustom ={
      headers: [],
      players: []
    };
    dispatch(setCustomAlerts(defaultCustom, user, teamId));
  }else{
    defaultCustom = JSON.parse(results[0].customfieldview);
    dispatch(setCustomAlerts(defaultCustom, user, teamId));
  }
};   
};

export const saveTableAlerts = (user, teamId, customAlerts) =>{
  return async (dispatch) => {
    const customAlertsToSend = customAlerts;
    const jsonBody = JSON.stringify(customAlertsToSend);
    fetch(SERVER.SET_CUSTOM_ALERTS(user, teamId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .finally(() => {
        dispatch(loadTableAlerts(user, teamId));
      });
};   
};

export const updateCustomEvents = (eventOne, eventTwo, eventThree, teamId, isMobile) =>{
  return async (dispatch) =>{
    const customEvents = [
      {
        name: eventOne ,
        displayName: eventOne,
        num: 1
        },
        {
          name: eventTwo,
          displayName: eventTwo,
          num: 2
        },
        {
          name: eventThree,
          displayName: eventThree,
          num: 3
        }
    ];
    const jsonBody = JSON.stringify(customEvents);
    fetch(SERVER.SET_CUSTOM_EVENTS(teamId, isMobile), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .finally(() => {
        dispatch(loadCustomEvents(teamId, isMobile));
      });
  };

};
// SPEED ALERTS

export const loadSpeedAlerts = (user, teamId) =>{
  return async (dispatch) => {
  const results = await requestData(SERVER.GET_SPEED_ALERTS(user, teamId));
  let defaultCustom;
  if(!results || results.length === 0){
    defaultCustom =[];
    dispatch(setSpeedAlerts(defaultCustom, teamId));
  }else{
    defaultCustom = results;
    dispatch(setSpeedAlerts(defaultCustom, teamId));
  }
};   
};

export const saveUpdateSpeedAlerts = (user, teamId, speedAlerts) =>{
  return async (dispatch) =>{
    const jsonBody = JSON.stringify(speedAlerts);
    fetch(SERVER.GET_SPEED_ALERTS(user, teamId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .finally(() => {
        dispatch(loadSpeedAlerts(user, teamId));
      }); 
};
};
